import { API_URL } from "constants/index";
import { fetchWithAuth } from "shared/api/fetch-with-auth";
import { BuildingDTO } from "shared/types/building";

export const calculateBuildingPlansInfoDotValues = async (building: BuildingDTO, session: any) => {
    let dotValues: any = {
        red: { count: 0, labels: [] },
        orange: { count: 0, labels: [] },
        green: { count: 0, labels: [] },
        transparent: { count: 0, labels: [] },
    };

    try {
        const queryParams = new URLSearchParams();
        if (building?.id) {
            queryParams.append('buildingId', building.id);
        }

        const labels = [
            "Plan landmeter",
            "Plan uitvoering",
            "Plan elektriciteit",
            "Plan sanitair",
            "Plan verwarming",
            "Plan interieur",
            "Plan gevel",
            "Plan grondplan",
            "Plan inplanting",
            "Plan voorstel nieuwe toestand",
            "Plan voorontwerp",
            "Plan commerciëel",
            "Plan kadaster",
            "Plan generiek",
            "Plan vergunning",
        ];
        queryParams.append('labels', labels.join(','));

        const response = await fetchWithAuth(
            `${API_URL}/file/get-file-logs?${queryParams.toString()}`,
            { method: 'GET' },
            session
        );
        const fileLogs = await response.json();
        
        // Check if any plans exist
        if (!fileLogs || fileLogs.length === 0) {
            dotValues.transparent.count++;
            dotValues.transparent.labels.push("Geen plannen aanwezig");
            return dotValues;
        }
        
        // Create a map to track which plan types we've found
        const planTypes = new Map();
        
        // Check for each plan type
        fileLogs.forEach((log: any) => {
            const label = log.label;
            
            if (label.includes("Plan landmeter") && !planTypes.has("Plan landmeter")) {
                dotValues.green.count++;
                dotValues.green.labels.push("Plan landmeter aanwezig");
                planTypes.set("Plan landmeter", true);
            }
            
            if (label.includes("Plan uitvoering") && !planTypes.has("Plan uitvoering")) {
                dotValues.green.count++;
                dotValues.green.labels.push("Plan uitvoering aanwezig");
                planTypes.set("Plan uitvoering", true);
            }
            
            if (label.includes("Plan elektriciteit") && !planTypes.has("Plan elektriciteit")) {
                dotValues.green.count++;
                dotValues.green.labels.push("Plan elektriciteit aanwezig");
                planTypes.set("Plan elektriciteit", true);
            }
            
            if (label.includes("Plan sanitair") && !planTypes.has("Plan sanitair")) {
                dotValues.green.count++;
                dotValues.green.labels.push("Plan sanitair aanwezig");
                planTypes.set("Plan sanitair", true);
            }
            
            if (label.includes("Plan verwarming") && !planTypes.has("Plan verwarming")) {
                dotValues.green.count++;
                dotValues.green.labels.push("Plan verwarming aanwezig");
                planTypes.set("Plan verwarming", true);
            }
            
            if (label.includes("Plan interieur") && !planTypes.has("Plan interieur")) {
                dotValues.green.count++;
                dotValues.green.labels.push("Plan interieur aanwezig");
                planTypes.set("Plan interieur", true);
            }
            
            if (label.includes("Plan gevel") && !planTypes.has("Plan gevel")) {
                dotValues.green.count++;
                dotValues.green.labels.push("Plan gevel aanwezig");
                planTypes.set("Plan gevel", true);
            }
            
            if (label.includes("Plan grondplan") && !planTypes.has("Plan grondplan")) {
                dotValues.green.count++;
                dotValues.green.labels.push("Plan grondplan aanwezig");
                planTypes.set("Plan grondplan", true);
            }
            
            if (label.includes("Plan inplanting") && !planTypes.has("Plan inplanting")) {
                dotValues.green.count++;
                dotValues.green.labels.push("Plan inplanting aanwezig");
                planTypes.set("Plan inplanting", true);
            }

            if (label.includes("Plan voorstel nieuwe toestand") && !planTypes.has("Plan voorstel nieuwe toestand")) {
                dotValues.green.count++;
                dotValues.green.labels.push("Plan voorstel nieuwe toestand aanwezig");
                planTypes.set("Plan voorstel nieuwe toestand", true);
            }

            if (label.includes("Plan voorontwerp") && !planTypes.has("Plan voorontwerp")) {
                dotValues.green.count++;
                dotValues.green.labels.push("Plan voorontwerp aanwezig");
                planTypes.set("Plan voorontwerp", true);
            }

            if (label.includes("Plan commerciëel") && !planTypes.has("Plan commerciëel")) {
                dotValues.green.count++;
                dotValues.green.labels.push("Plan commerciëel aanwezig");
                planTypes.set("Plan commerciëel", true);
            }

            if (label.includes("Plan kadaster") && !planTypes.has("Plan kadaster")) {
                dotValues.green.count++;
                dotValues.green.labels.push("Plan kadaster aanwezig");
                planTypes.set("Plan kadaster", true);
            }

            if (label.includes("Plan generiek") && !planTypes.has("Plan generiek")) {
                dotValues.green.count++;
                dotValues.green.labels.push("Plan generiek aanwezig");
                planTypes.set("Plan generiek", true);
            }

            if (label.includes("Plan vergunning") && !planTypes.has("Plan vergunning")) {
                dotValues.green.count++;
                dotValues.green.labels.push("Plan vergunning aanwezig");
                planTypes.set("Plan vergunning", true);
            }

            if (label.includes("Plan voorstel nieuwe toestand") && !planTypes.has("Plan voorstel nieuwe toestand")) {
                dotValues.green.count++;
                dotValues.green.labels.push("Plan voorstel nieuwe toestand aanwezig");
                planTypes.set("Plan voorstel nieuwe toestand", true);
            }
        });
        
        // If we found no plans (could happen if labels don't match any of our checks)
        if (dotValues.green.count === 0) {
            dotValues.transparent.count++;
            dotValues.transparent.labels.push("Geen plannen aanwezig");
        }
        
    } catch (error) {
        console.error('Error fetching building plan logs:', error);
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Fout bij ophalen plannen");
    }

    return dotValues;
};
